// Cards
import ChartCard from "./Cards/ChartCard.vue";
import NavTabsCard from "./Cards/NavTabsCard.vue";
import StatsCard from "./Cards/StatsCard.vue";

// Tables
import NavTabsTable from "./Tables/NavTabsTable.vue";
import OrderedTable from "./Tables/OrderedTable.vue";
import SimpleTable from "./Tables/SimpleTable.vue";

export {
  ChartCard,
  NavTabsCard,
  StatsCard,
  NavTabsTable,
  OrderedTable,
  SimpleTable
};
